export type AppKind =
  | 'listener'
  | 'account'
  | 'login'
  | 'admin'
  | 'dj-desktop'
  | 'dj-mobile'
  | 'guest';

export interface AppRegistration {
  kind: AppKind;
  basePath: string;
  title: string;
  audience: 'public' | 'authenticated' | 'invitation';
}

export const appRegistry: readonly AppRegistration[] = [
  { kind: 'account', basePath: '/account', title: 'Безпека акаунта', audience: 'authenticated' },
  { kind: 'login', basePath: '/login', title: 'Вхід', audience: 'authenticated' },
  { kind: 'admin', basePath: '/admin', title: 'Керування радіо', audience: 'authenticated' },
  { kind: 'dj-desktop', basePath: '/studio', title: 'Ефірна студія', audience: 'authenticated' },
  { kind: 'dj-mobile', basePath: '/dj', title: 'Мобільний пульт', audience: 'authenticated' },
  { kind: 'guest', basePath: '/guest', title: 'Гостьова студія', audience: 'invitation' },
  { kind: 'listener', basePath: '/', title: 'Радіо', audience: 'public' },
] as const;

export function resolveApp(path: string): AppRegistration {
  return appRegistry.find(({ basePath }) =>
    basePath === '/' ? path === '/' : path === basePath || path.startsWith(`${basePath}/`),
  ) ?? appRegistry[appRegistry.length - 1]!;
}
